import { render, staticRenderFns } from "./login.vue?vue&type=template&id=2eb1059c&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/home/ec2-user/environment/xsearch-app/src/components/Header.vue').default,Footer: require('/home/ec2-user/environment/xsearch-app/src/components/Footer.vue').default})
